"use client";

import Link from "next/link";
import { ICONS } from "@artha/icons";
import { ProfileAvatar, Typography } from "@artha/ui";
import type { CreatorDetailHeaderProps } from "./creatorDetail.types";

export function CreatorDetailHeader({
  username,
  creatorName,
  creatorAvatarUrl,
  title,
  backHref,
  backLabel,
}: CreatorDetailHeaderProps) {
  return (
    <header className="sticky top-0 z-30 -mx-4 px-4 py-3 bg-[#FFF8E8]">
      <div className="flex items-center gap-1 min-w-0">
        <Link
          href={backHref}
          className="rounded-md p-1 text-[#344054]"
          aria-label={backLabel}
        >
          <ICONS.ARROW_LEFT className="h-5 w-5 text-[#344054]" />
        </Link>
        <div className="flex items-center gap-2 min-w-0">
          <ProfileAvatar
            src={creatorAvatarUrl}
            alt={creatorName || username}
            className="h-8 w-8 shrink-0 rounded-full border border-black"
            fallbackClassName="bg-white"
            logoClassName="h-[54%] w-[54%]"
          />
          <Typography
            variant="small"
            className="text-[#344054] text-[14px] font-medium truncate"
          >
            {title || creatorName || username}
          </Typography>
        </div>
      </div>
    </header>
  );
}
